'use client';

import { type PropsWithChildren, createContext, useContext } from 'react';
import { ThemeProvider as EQIThemeProvider } from '@eqi-investimentos/react';
import useLocalStorage from '@/hooks/useLocalstorage';
import { Aeonik } from '../themes/fonts';
export const ThemeContext = createContext({} as ThemeContextData);
export const ThemeProvider = ({
  children
}: Readonly<PropsWithChildren>) => {
  const [isDarkMode, setIsDarkMode] = useLocalStorage('@theme', false);
  const toggleTheme = () => setIsDarkMode(prevMode => !prevMode);
  return <ThemeContext.Provider value={{
    isDarkMode,
    toggleTheme
  }} data-sentry-element="unknown" data-sentry-component="ThemeProvider" data-sentry-source-file="ThemeContext.tsx">
      <EQIThemeProvider fontFamily={Aeonik.style.fontFamily} colorScheme="dark" data-sentry-element="EQIThemeProvider" data-sentry-source-file="ThemeContext.tsx">
        {children}
      </EQIThemeProvider>
    </ThemeContext.Provider>;
};
export const useTheme = () => useContext(ThemeContext);
type ThemeContextData = {
  isDarkMode: boolean;
  toggleTheme: () => void;
};